import React from 'react'
import Content from '../../../Components/Dashboard/Content/Content'
import BrokerOptionsChain from '../../../Components/Dashboard/Content/BrokerOptionsChain'

export default function Optionchain() {
    return (
        <Content>
            <BrokerOptionsChain />
        </Content>
    )
}
